import { Component } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppDialogUiReduxObject, DialogBaseComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html/safe-html.pipe';

@Component({
  selector: 'sl-ui-kit-raw-html-dialog',
  templateUrl: './raw-html-dialog.component.html',
  styleUrls: ['./raw-html-dialog.component.scss'],
  imports: [SafeHtmlPipe]
})
export class RawHtmlDialogComponent extends DialogBaseComponent {
  static ClassId = 'RAW_HTML_DIALOG_1929c408-be07-4bae-9c5b-4a1bc3996ebf';

  constructor(reduxDialogObject: AppDialogUiReduxObject, modalService: BsModalService, store: Store<any>, actions: Actions<any>, modalRef: BsModalRef) {
    super(reduxDialogObject, modalService, store, actions, modalRef);
  }
}
